/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadPanel, TreeView } from "devextreme-react";
import { useAuth } from "../../contexts/auth";
import { showNavigation } from "../../redux/actions";
import { responseNavigation } from "../../redux/reducers";
import { useNavigation } from "../../contexts/navigation";
import { useScreenSize } from "../../utils/media-query";
import { AdminNavigation } from "../../common";
import { Footer } from "../../components";
import "./style.scss";

import * as events from "devextreme/events";

export default function SideNavigationMenu({
  children,
  selectedItemChanged,
  openMenu,
  compactMode,
  onMenuReady,
}) {
  const dispatch = useDispatch();
  const { navigation } = useSelector(responseNavigation);
  const { isSmall } = useScreenSize();
  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const { user } = useAuth();

  useEffect(() => {
    // if (!user.EmployeeUserOid) {
    //   window.location.reload();
    //   return;
    // }
    dispatch(showNavigation(user.EmployeeUserOid));
  }, [dispatch]);

  function normalizePath() {
    if (navigation.length === 0) {
      return;
    }
    let newNavigation = [];
    if (user.Queryable !== "queryable_special@123") {
      newNavigation = [...navigation];
    } else {
      newNavigation = [...navigation, AdminNavigation];
    }
    // navigation.push(AdminNavigation);

    return newNavigation.map((item) => {
      if (item.path && !/^\//.test(item.path)) {
        item.path = `/${item.path}`;
      }
      const changedPath = item.items.map((data) => {
        const currentPath = `${item.path}${data.path}`;
        const newPath = { ...data, path: currentPath };
        return newPath;
      });
      const newItem = { ...item, items: changedPath };
      return { ...newItem, expanded: isSmall };
    });
  }

  const items = useMemo(normalizePath, [navigation]);

  const {
    navigationData: { currentPath },
  } = useNavigation();
  const getLanguageDisplay = () => {
    const language = localStorage.getItem("locale");
    const object = {
      en: "text",
      vi: "textVi",
      ja: "textJa",
    };
    return object[language] ?? "textVi";
  };

  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, "dxclick");
      }

      wrapperRef.current = element;
      events.on(element, "dxclick", (e) => {
        openMenu(e);
      });
    },
    [openMenu]
  );
  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }
    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div className={"side-navigation-menu"} ref={getWrapperRef}>
      {children}
      <div className={"menu-container"}>
        {items ? (
          <TreeView
            ref={treeViewRef}
            items={items}
            keyExpr={"path"}
            selectionMode={"single"}
            focusStateEnabled={false}
            displayExpr={getLanguageDisplay()}
            expandEvent={"click"}
            onItemClick={selectedItemChanged}
            onContentReady={onMenuReady}
            width={"100%"}
          />
        ) : (
          <LoadPanel visible={true} />
        )}
      </div>
      <Footer>
        <h4>e-Caputtin'o</h4>
        Version 2.0.0
        <br />
        Copyright (c) 2006-{new Date().getFullYear()} NEC Vietnam Co., Ltd. All
        Rights Reserved
        <br />
        Human resource management system
      </Footer>
    </div>
  );
}
